// ============================================================================
// OBT F3-C — Raporlama ve analitik ekranı (Müdür / MY / BM)
// ============================================================================
// SALT-OKUNUR: iş akışını DEĞİŞTİRMEZ, onay/karar YAZMAZ. Kapsam backend'de
// (JWT + ChainService) çözülür; ekran hiçbir aktör/scope göndermez. Yalnız
// backend'in gerçekten döndürdüğü veriden rapor üretilir — eksik metrikler
// dürüstçe belirtilir, sahte veri/uydurma export YOKTUR.
// ============================================================================
import { useState } from 'react';
import { ArrowLeft, LayoutDashboard, Megaphone, MapPin, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ObtPageHeader } from '../ObtStates';
import OverviewPanel from './OverviewPanel';
import CampaignsPanel from './CampaignsPanel';
import ParkReportPanel from './ParkReportPanel';
import RespondentPanel from './RespondentPanel';

const TABS = [
  { key: 'overview', label: 'Genel Bakış', icon: LayoutDashboard },
  { key: 'campaigns', label: 'Bilgi Talepleri', icon: Megaphone },
  { key: 'parks', label: 'Park Raporu', icon: MapPin },
  { key: 'people', label: 'Personel', icon: Users },
];

/**
 * @param {object} props
 * @param {'director'|'deputy'|'engineer'} [props.role]
 * @param {boolean} [props.enabled]
 * @param {() => void} [props.onBack]
 */
export default function ObtReportsScreen({ role = 'director', enabled = true, onBack }) {
  const [tab, setTab] = useState('overview');

  return (
    <div className="space-y-4">
      <ObtPageHeader
        onBack={onBack}
        title="Raporlama ve Analitik"
        description="Bilgi Talebi, park ve personel bazlı OBT analizleri (salt-okunur)."
      />

      <div role="tablist" aria-label="Rapor sekmeleri" className="flex flex-wrap gap-1.5">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => setTab(t.key)}
              className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium ring-1 ring-inset ${
                active
                  ? 'bg-blue-600 text-white ring-blue-600'
                  : 'bg-white text-gray-700 ring-gray-300 hover:bg-gray-50'
              }`}
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
              {t.label}
            </button>
          );
        })}
      </div>

      <div role="tabpanel">
        {tab === 'overview' && <OverviewPanel enabled={enabled} />}
        {tab === 'campaigns' && <CampaignsPanel enabled={enabled} />}
        {tab === 'parks' && <ParkReportPanel enabled={enabled} />}
        {tab === 'people' && <RespondentPanel enabled={enabled} role={role} />}
      </div>
    </div>
  );
}
